import React from 'react';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { moduleTypeSelect } from 'src/tools/contentModulesFieldName';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;

const GridType = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled, options } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('salesChannelContent.index.gridType')}>
        <Field name={moduleTypeSelect}>
          <OriSelect
            disabled={disabled}
            size='large'
            //   value={moduleWidth}
            //   onChange={handleOnModuleWidthChange}
          >
            {options.map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default GridType;
